import { render, staticRenderFns } from "./IconInfoCircle.vue?vue&type=template&id=74eae716&"
import script from "./IconInfoCircle.vue?vue&type=script&lang=js&"
export * from "./IconInfoCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports